import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const hintLocaleModule: LocaleModule = {
  name: "hint",
  messages: { en: en, it: it },
};
